import { Helmet } from "react-helmet-async"
import { ForbidUnlessAuthorized, PERMISSIONS } from "../../../../../Auth"
import { HotelPreferencesList } from "../../../../../SupplierPaymentPreferences/Hotel"

const hotel = () => {
	return (
		<>
			<Helmet>
				<title>Hotel Payment Preferences</title>
			</Helmet>
			<ForbidUnlessAuthorized permission={PERMISSIONS.VIEW_HOTEL_SUPPLIERS}>
				<HotelPreferencesList />
			</ForbidUnlessAuthorized>
		</>
	)
}

export default hotel
